import { gql } from "@apollo/client";

export const GetCustomerTargets = gql`
  query GetSalesOrderSummary(
  $startDate: Date,
  $endDate: Date,
  $roles: [String],
  $agents: [String]
) {
  getSalesOrderSummary(
    startDate: $startDate,
    endDate: $endDate,
    roles: $roles,
    agents: $agents
  ) {
    success
    error
    message
    data {
      customerName
      agentName
      roleName
      totalOrders
      completedOrders
      pendingOrders
    }
  }
}

`;

export const exportCustomerMaster = gql`
 mutation ExportSalesOrderSummary($startDate: Date, $endDate: Date, $roles: [String], $agents: [String]) {
  exportSalesOrderSummary(startDate: $startDate, endDate: $endDate, roles: $roles, agents: $agents) {
    success
    error
    message
    fileUrl
  }
}


`;


export const GetExecutiveWiseTarget = gql`
  query GetExecutiveTargets(
  $startDate: Date
  $endDate: Date
  $roles: [String]
  $agents: [String]
  $page: Int
  $pageSize: Int
) {
  getExecutiveTargets(
    startDate: $startDate
    endDate: $endDate
    roles: $roles
    agents: $agents
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    error
    totalCount
    totalPages
    currentPage
    data {
      agentId
      agentName
      customerTargetAssigned
      customerTargetCompleted
      customerTargetPending
      paymentTargetAssigned
      paymentTargetCompleted
      paymentTargetPending
      merchandiseTargetAssigned
      merchandiseTargetCompleted
      merchandiseTargetPending
    }
  }
}
`;

export const exportExecutiveWiseTarget = gql`
 mutation ExportExecutiveTarget(
  $startDate: Date
  $endDate: Date
  $roles: [String]
  $agents: [String]
) {
  exportExecutiveTarget(
    startDate: $startDate
    endDate: $endDate
    roles: $roles
    agents: $agents
  ) {
    success
    error
    message
    fileUrl
  }
}


`;

export const getSalesOrderSummaryReport = gql`
query GetSalesOrderSummary(
  $startDate: Date
  $endDate: Date
  $roles: [String]
  $agents: [String]
  $page: Int
  $pageSize: Int
) {
  getSalesOrderSummary(
   startDate: $startDate
   endDate: $endDate
   roles: $roles
   agents: $agents
   page: $page
   pageSize: $pageSize
  ) {
   success
   error
   message
   totalAssigned
   totalAchieved
   totalPending
   totalCount
   currentPage
   totalPages
   hasNext
   hasPrevious
   data {
     repCode
     repName
     completed
     pending
     assigned
   }
  }
}`


//get roles
export const allRoles = gql`
  query allRoles {
    allRoles {
      data {
        id
        role
        description
      }
      success
      error
      message
    }
  }
`;

//get agent
export const allUsers = gql`
  query {
    allUsers {
      id

      employeeName

      employeeCode

      email

      contactNumber

      address

      role {
        id
        role
      }

      department {
        id
        departmentName
      }
      createdAt

      profilePicture

      webUse

      mobileUse
    }
  }
`;

//get allCustomers
export const allCustomers = gql`
  query {
    allCustomers {
      id

      customerCategory

      customerCode

      customerName

      priceCode

      repName

      repCode

      status
    }
  }
`;

//get allProductCategories
export const allProductCategories = gql`
  query {
    allProductCategories {
      data {
        id

        categoryCode

        categoryName

        categoryDescription

        createdAt

        lastupdate

        user {
          id
        }
      }

      success

      error

      message
    }
  }
`;
//get allBrands
export const allBrands = gql`
  query {
    allBrands {
      data {
        id
        brandName
        brandDescription
        brandLogo
        createdAt
        lastupdate
        user {
          id
        }
      }
      success
      error
      message
    }
  }
`;

//get allProducts
export const allProducts = gql`
  query {
    allProducts {
      success
      error
      message
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productImage
        productUom
        baseUom
        conversion
        bas
        cod
        csh
        smt
        vansl
        createdAt
        lastupdate
      }
    }
  }
`;

export const GetPaymentCollectionSummary = gql`query GetPaymentCollectionSummary(
  $startDate: Date
  $endDate: Date
  $roles: [String]
  $agents: [String]
  $page: Int
  $pageSize: Int
) {
  getPaymentCollectionSummary(
    startDate: $startDate
    endDate: $endDate
    roles: $roles
    agents: $agents
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
    totalCount
    totalPages
    currentPage
    totalAssigned
    totalAchieved
    totalPending
    data {
      repCode
      repName
      assigned
      completed
      pending
    }
  }
}
`;

export const ExportPaymentCollection = gql`
mutation ExportPaymentCollection(
  $startDate: Date,
  $endDate: Date,
  $roles: [String],
  $agents: [String]
) {
  exportPaymentCollectionSummary(
    startDate: $startDate,
    endDate: $endDate,
    roles: $roles,
    agents: $agents
  ) {
    success
    error
    message
    fileUrl
  }
}
`;

